import React, { useState } from 'react';



import Popup from '../../../../../components/Popup';
import Input from '../../../../../components/Input';
import {  FaFileInvoiceDollar, FaRegFolder } from 'react-icons/fa';
import billServices from '../../../../../services/admFin/billServices';
import PopupSelectProducts from './PopupSelectProducts';


export default function PopupXml(props) { 
    const [products, setProducts] = useState([]);
    const [visibility, setVisibility] = useState(false);
    
    
    async function onClick() {
        try {
            const response = await billServices.postXml(props.xml);
            console.log(response)
            await props.readInfoNewBill();
            props.setCompany(response.data.empresa.nome);
            props.setPartner(response.data.fornecedor.nome);
            setProducts(response.data.produtos);
            //console.log("Produtos", response.data.produtos);
            //console.log("Produtos Lista", props.productsList);
            //props.setProducts(products);
            props.setInstallments([{
                valor: response.data.valor,
                data_venc: "",
                paga: false,
                data_pag: "",
                valor_pago: 0
            }])
            setVisibility(true);
        }
        catch (err) {
            console.log(err)
            alert(err);
            props.cleanStates();
        }
        props.setVisibility(false);
    }
    

    return (
        <div>
            <Popup
                visibility={props.visibility}
                setVisibility={props.setVisibility}
                icon={<FaFileInvoiceDollar />}
                tittle="XML"
            >
                <form>
                    <Input
                        type='file'
                        accept='text/xml'
                        className='new-bill-xml-pop-up-input'
                        id='new-bill-xml-pop-up-input'
                        label="Selecionar arquivo XML*"
                        icon={<FaRegFolder />}
                        onChange={e => props.setXml(e.target.files[0])}
                        value={props.xml}
                    />
                    
                    <button type="button" onClick={onClick}>
                        Enviar XML
                    </button>
                </form>
            </Popup>
            <PopupSelectProducts
                visibility={visibility}
                setVisibility={setVisibility}
                productsList={props.productsList}
                setProductsList={props.setProductsList}
                products={products}
                setProducts={setProducts}
                setProductsBill={props.setProducts}
            />
        </div>
    )
}